module.exports = __webpack_public_path__ + "img/south-africa.112b98e6.svg";